var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMovFileTypeSvgrepoCom({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 400 400",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#101010;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "xxx-word"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M325,105H250a5,5,0,0,1-5-5V25a5,5,0,1,1,10,0V95h70a5,5,0,0,1,0,10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M325,154.83a5,5,0,0,1-5-5V102.07L247.93,30H100A20,20,0,0,0,80,50v98.17a5,5,0,0,1-10,0V50a30,30,0,0,1,30-30H250a5,5,0,0,1,3.54,1.46l75,75A5,5,0,0,1,330,100v49.83A5,5,0,0,1,325,154.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M300,380H100a30,30,0,0,1-30-30V275a5,5,0,0,1,10,0v75a20,20,0,0,0,20,20H300a20,20,0,0,0,20-20V275a5,5,0,0,1,10,0v75A30,30,0,0,1,300,380Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M275,280H125a5,5,0,1,1,0-10H275a5,5,0,0,1,0,10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M200,330H125a5,5,0,1,1,0-10h75a5,5,0,0,1,0,10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M325,280H75a30,30,0,0,1-30-30V173.17a30,30,0,0,1,30-30h.2l250,1.66a30.09,30.09,0,0,1,29.81,30V250A30,30,0,0,1,325,280ZM75,153.17a20,20,0,0,0-20,20V250a20,20,0,0,0,20,20H325a20,20,0,0,0,20-20V174.83a20.06,20.06,0,0,0-19.88-20l-250-1.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M179.45,236h-9.8V189.32L154.88,236h-5L135,189.32V236h-7.85V182.68h15L153.36,217l11-34.34h15.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M210.86,236.82q-10.63,0-16.54-8t-5.92-19.69q0-11.64,6.29-19.47a20.25,20.25,0,0,1,16.6-7.83q10.39,0,16.43,7.83t6,19.59q0,12.34-6.27,19.94A20.47,20.47,0,0,1,210.86,236.82Zm.08-7.73a11.05,11.05,0,0,0,8.79-4.3q3.59-4.3,3.59-15.59,0-9.18-3-14.39a9.88,9.88,0,0,0-9.22-5.21q-12.34,0-12.34,19.88,0,9.65,3.14,14.63A10,10,0,0,0,210.94,229.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M261.84,236h-9.77l-16.45-53.32h10.16L258,223.54l12.5-40.86h8Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMovFileTypeSvgrepoCom);
export default __webpack_public_path__ + "static/media/mov-file-type-svgrepo-com.6ed8f1dc2bb9f29b75ec6255395c399d.svg";
export { ForwardRef as ReactComponent };